import React from 'react';
import { Communication, CommChannel, CommDirection } from '../../services/communicationService';
import CommunicationTimelineItem from './CommunicationTimelineItem';

interface Props {
  items: Communication[];
  isLoading: boolean;
  channelFilter: '' | CommChannel;
  directionFilter: '' | CommDirection;
  onChannelFilter: (v: '' | CommChannel) => void;
  onDirectionFilter: (v: '' | CommDirection) => void;
  onOpenMessage: (item: Communication) => void;
  onCompose: () => void;
  canCompose: boolean;
  userTimezone: string;
}

const selectClass =
  'text-xs px-2 py-1 rounded bg-[#EBF5F5] border border-[#B4D9D4] focus:outline-none';

const CommunicationsPanel: React.FC<Props> = ({
  items, isLoading, channelFilter, directionFilter,
  onChannelFilter, onDirectionFilter, onOpenMessage, onCompose, canCompose, userTimezone,
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="text-sm font-bold text-gray-900">Communications</h3>
        <div className="flex items-center gap-2 flex-wrap">
          <select
            value={channelFilter}
            onChange={(e) => onChannelFilter(e.target.value as '' | CommChannel)}
            className={selectClass}
          >
            <option value="">All channels</option>
            <option value="EMAIL">Email</option>
            <option value="SMS">SMS</option>
          </select>
          <select
            value={directionFilter}
            onChange={(e) => onDirectionFilter(e.target.value as '' | CommDirection)}
            className={selectClass}
          >
            <option value="">All directions</option>
            <option value="OUTGOING">Sent</option>
            <option value="INCOMING">Received</option>
          </select>
          <button
            onClick={onCompose}
            disabled={!canCompose}
            title={canCompose ? 'Compose email' : 'Patient has no email address'}
            className="px-3 py-1 text-xs bg-teal-600 text-white rounded hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Compose Email
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-400" />
        </div>
      ) : items.length === 0 ? (
        <div className="text-center text-sm text-gray-500 py-8">No communications yet</div>
      ) : (
        <div className="space-y-2">
          {items.map((item) => (
            <CommunicationTimelineItem
              key={item.id}
              item={item}
              onClick={onOpenMessage}
              userTimezone={userTimezone}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CommunicationsPanel;
